export var Logger;
(function (Logger) {
    const NOOP_LOGGER = Object.freeze({});
    Logger.LEVELS = ['trace', 'debug', 'info', 'warn', 'error'];
    function noOp() {
        return NOOP_LOGGER;
    }
    Logger.noOp = noOp;
    function withLevel(delegate, level) {
        const logger = {};
        for (let i = Logger.LEVELS.indexOf(level); i >= 0 && i < Logger.LEVELS.length; i++) {
            logger[Logger.LEVELS[i]] = delegate[Logger.LEVELS[i]]?.bind(delegate);
        }
        return Object.freeze(logger);
    }
    Logger.withLevel = withLevel;
})(Logger || (Logger = {}));
//# sourceMappingURL=logger.js.map